import * as React from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import InvitationItem from './invitation-item';
import RenderForm from './search-form';

const styles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2, 2),
    marginBottom: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
}));

export default ({
  initialValues, onSubmit, results, setActiveInvitation,
}) => {
  const { t } = useTranslation();
  const classes = styles();

  return (
    <>
      <Typography gutterBottom>
        <Link to="/app" className={classes.link}>
          <i className="fa fa-share fa-flip-horizontal"></i> {t('Go back')}
        </Link>
      </Typography>
      <Grid container spacing={2} justify="center">
        <Grid item xs={12}>
          <Paper elavation={3} square className={classes.paper}>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validate={(values) => {
                const errors = {};

                if (!values.type) {
                  errors.type = 'Required';
                }

                if (!values.value) {
                  errors.value = 'Required';
                }

                return errors;
              }}
              onSubmit={
                async (values, { setSubmitting, setErrors }) => {
                  try {
                    await onSubmit({ ...values });
                    setSubmitting(false);
                  } catch (err) {
                    if (err.response && err.response.data.errors) {
                      setErrors(err.response.data.errors);
                    }

                    setSubmitting(false);
                  }
                }
              }
              render={RenderForm}
            />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          {
            results && !results.length &&
            <Alert elevation={6} variant="filled" severity="info" icon={false}>
              {t('There are no invitations that match the search')}
            </Alert>
          }
        </Grid>
        <Grid item xs={12}>
          {
            results && !!results.length && (
              <>
                {
                  results.map((invitation, i) => {
                    if(!!invitation) {
                      return (
                        <Grid item container spacing={2} justify="center" key={i} >
                          <Grid item container xs={12} sm={9} md={9} lg={6}>
                            <InvitationItem invitation={invitation} setActiveInvitation={setActiveInvitation} />
                          </Grid>
                        </Grid>
                      )
                    }                    
                  })
                }

              </>
            )
          }
        </Grid>
      </Grid>
    </>
  );
}
